<script lang="ts" setup>
import {
  PopoverAnchor,
  PopoverArrow,
  PopoverContent,
  PopoverPortal,
  PopoverRoot,
} from "reka-ui";
import { ref } from "vue";
import ForgetPoolModal from "@/features/ble/modals/ForgetPoolModal.vue";
import { PoolDetails } from "@/models/pool-details.model.ts";
import { renamePool } from "@/features/ble/utils/localStorage.ts";

const { pool } = defineProps<{
  pool?: PoolDetails & { deviceId: string; localNickname: string };
}>();

const popoverOpen = ref(false);

const timeout = ref<number | undefined>(undefined);

const onPointerDown = () => {
  timeout.value = window.setTimeout(() => {
    popoverOpen.value = true;
  }, 500);
};

const onPointerUp = () => {
  window.clearTimeout(timeout.value);
};

const onClickCapture = ($event: MouseEvent) => {
  if (popoverOpen.value) {
    $event.stopPropagation();
  }
};

const forgetModalOpened = ref(false);
</script>

<template>
  <ForgetPoolModal
    :pool="pool"
    :opened="forgetModalOpened"
    @cancel="forgetModalOpened = false"
    @submit="forgetModalOpened = false"
  />

  <div
    class="contents"
    @pointerdown.capture="onPointerDown"
    @pointerup="onPointerUp"
  >
    <PopoverRoot :open="popoverOpen && pool">
      <PopoverAnchor
        as-child
        @click.capture="onClickCapture"
        class="select-none"
        ><slot
      /></PopoverAnchor>
      <PopoverPortal>
        <PopoverContent
          class="bg-gray-200 text-sm rounded shadow-lg font-medium"
          @interactOutside="popoverOpen = false"
          @pointerDownOutside="popoverOpen = false"
          @focusOutside="popoverOpen = false"
        >
          <PopoverArrow class="fill-gray-200" />
          <div class="flex">
            <div
              class="p-2 border-r border-r-gray-300"
              @click="
                popoverOpen = false;
                forgetModalOpened = true;
              "
            >
              Oublier ce bassin
            </div>
            <div
              class="p-2"
              @click="
                popoverOpen = false;
                renamePool(pool);
              "
            >
              Renommer ce bassin
            </div>
          </div>
        </PopoverContent>
      </PopoverPortal>
    </PopoverRoot>
  </div>
</template>
